import { render } from "./Loading.vue?vue&type=template&id=01225a7d"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=01225a7d&lang=scss"
script.render = render

export default script